export default __webpack_public_path__ + "static/media/stake.2157b85f.svg";